export const badgeProps = [
    {
        type: "TSAMLUSR",
        value: "EXTERNAL"
    },
    {
        type: "TOPENIDUSR",
        value: "External"
    },
    {
        type: "TUSR",
        value: "platform"
    },
    {
        type: "TC",
        value: "system"
    },
    {
        type: "TD",
        value: "platform"
    },
    {
        type: "TPD",
        value: "app"
    },
    {
        type: "APPLICATION",
        value: "app"
    },
    {
        type: "SYSTEM",
        value: "system"
    },
    {
        type: "PLATFORM",
        value: "platform"
    },
    {
        type: "EXTERNAL",
        value: "external"
    }
];

export const avatarProps = [
    {
        type: "EXTERNAL",
        value: "externalUser"
    },
    {
        type: "AD",
        value: "externalGroup"
    },
    {
        type: "TUSR",
        value: "userPlatform"
    },
    {
        type: "TSAMLUSR",
        value: "externalUser"
    },
    {
        type: "TOPENIDUSR",
        value: "externalUser"
    },
    {
        type: "TC",
        value: "system"
    },
    {
        type: "TD",
        value: "platform"
    },
    {
        type: "TPD",
        value: "applicationSpecific"
    },
    {
        type: "APPLICATION",
        value: "applicationSpecific"
    },
    {
        type: "SYSTEM",
        value: "system"
    },
    {
        type: "PLATFORM",
        value: "platform"
    }
];
